import React from 'react';
import { connect } from 'react-redux';
import Slide from '@material-ui/core/Slide';
import CloseIcon from '@material-ui/icons/Close';
import { MdDashboardCustomize } from "react-icons/md";
import Tooltip from '@material-ui/core/Tooltip';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import ZoomOutMapIcon from '@material-ui/icons/ZoomOutMap';
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit';
import { postData } from '../../functions/postData';

import CircularProgress from '@material-ui/core/CircularProgress';
import { arraysHaveSameValues, objectIsNotEmpty } from '../../functions/utils';
import { _ } from '../../functions/translator';

import { GridStack } from 'gridstack';
import 'gridstack/dist/gridstack.min.css';

import ReactDOM from 'react-dom';

class metricModule extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            metricsHTML: null,
            fullscreen: false,
            waitTimeToReload: 1000,
            reloadInProcess: false,
            showSuccesToast: false,
            showFailureToast: false,
            saveInDashboardLoading: false,
        };
    }

    componentDidMount() {
        this.gridContainer = document.querySelector(`.grid-stack-${this.props.metricKey}`);
        if (this.gridContainer && !this.gridContainer.classList.contains('gridstack-initialized')) {
            this.grid = GridStack.init({ float: true, cellHeight: 1, id: this.props.metricKey}, this.gridContainer );
            this.gridContainer.classList.add('gridstack-initialized');
        }
        this.loadMetric();
    }

    // initializeGrid = () => {
    //     if (!this.grid) {
    //         this.grid = GridStack.init({ float: true, id: this.props.metricKey, column: 40 });
    //     }
    // };

    componentDidUpdate(prevProps) {
        if (!arraysHaveSameValues(prevProps.visibleCardsGroupIds, this.props.visibleCardsGroupIds)
            || (prevProps.metrics !== this.props.metrics && this.props.metrics)) {
            if (!this.state.reloadInProcess) {
                this.setState({ reloadInProcess: true });
                setTimeout(this.loadMetric, this.state.waitTimeToReload);
            }
        }
    }

    updateGrid() {
        if (!this.grid || !this.state.metricsHTML) return;
        this.grid.removeAll();

        const el = document.createElement('div');
        el.classList.add('grid-stack-item');
        el.setAttribute('gs-w', '12');
        el.setAttribute('gs-h', '200');

        el.setAttribute('data-metric', this.props.metricKey);

        const contentWrapper = document.createElement('div');
        contentWrapper.classList.add('grid-stack-item-content');
        el.appendChild(contentWrapper);

        this.grid.el.appendChild(el);
        this.grid.makeWidget(el);
        ReactDOM.render(
                <iframe 
                    title="metric-iframe"
                    ref={ref => this.iframe = ref}
                    srcDoc={this.state.metricsHTML} 
                    width="100%"
                    height='100%'
                    frameborder="0"
                    onLoad={this.resizeIframe}>
                </iframe>
            ,
            contentWrapper
        );
    }


    loadMetric = async () => {
        this.setState({ reloadInProcess: false });
        if (this.state.metricsHTML) {
            this.setState({ metricsHTML: null });
        };
        const data = {
            project_id: this.props.projectId,
            chart_function_name: this.props.metricKey,
            layout_config: this.props.layoutConfig,
            break_user_names: true,
            users_data: this.props.usersData,
            extra_filters: {
                id: this.props.visibleCardsGroupIds,
            }
        };
        const response = await postData('/web-api/plotly-chart', data);
        this.setState({ metricsHTML: response }, this.updateGrid);

    }

    // renderMetricInGrid = () => {
    //     const gridEl = this.grid.el;
    //     gridEl.innerHTML = '';

    //     const el = document.createElement('div');
    //     el.classList.add('grid-stack-item');
    //     el.setAttribute('gs-w', '12');
    //     el.setAttribute('gs-h', '4');

    //     const contentWrapper = document.createElement('div');
    //     contentWrapper.classList.add('grid-stack-item-content');
    //     el.appendChild(contentWrapper);

    //     this.grid.el.appendChild(el);
    //     this.grid.makeWidget(el);

    //     ReactDOM.render(
    //         <div className='iframe-container'>
    //             <iframe 
    //                 title="metric-iframe"
    //                 ref={ref => this.iframe = ref}
    //                 srcdoc={this.state.metricsHTML} 
    //                 frameborder="0" 
    //                 width="100%" 
    //                 onLoad={this.resizeIframe}>
    //             </iframe>
    //         </div>,
    //         contentWrapper
    //     );
    // };

    resizeIframe = (event=null) => {
        const iframeObj = event ? event.target : this.iframe;
        if (!iframeObj) return;
        iframeObj.contentWindow.document.body.style.margin = '0px';
        iframeObj.contentWindow.document.body.style.overflowY = 'hidden';
        let iframeTotalHeight =  iframeObj.contentWindow.document.body.scrollHeight;
        //iframeObj.style.height = `${iframeTotalHeight}px`;
        iframeObj.style.width = '100%';
        this.removePlotlyIcon(iframeObj.contentWindow.document);
        setTimeout(() => {
            iframeObj.contentWindow.document.body.style.overflowY = 'auto';
        }, 1000);
    }
    
    removePlotlyIcon = (iframeDocument) => {
        const plotlyIconElements = iframeDocument.getElementsByClassName('modebar-btn plotlyjsicon modebar-btn--logo');
        if (plotlyIconElements.length) {
            plotlyIconElements[0].remove();
        }
    }

    handleFullScreen = () => {
        this.setState({ fullscreen: !this.state.fullscreen });
        this.resizeIframe();
    }

    handleClose = () => {
        this.props.closeCallback(this.props.metricKey);
    }

    setShowSuccessToast = (value) => {
        this.setState({ showSuccesToast: value });
    }

    setShowFailureToast = (value) => {
        this.setState({ showFailureToast: value });
    }

    saveInDashboard = async () => {
        this.setState({ saveInDashboardLoading: true });
        const signaturesFilters = this.props.signaturesFilterHistoric.reduce((acc, signature) => {
            const { signaturesFilter, signed } = signature;

            if (signaturesFilter.length === 0) return acc;

            const isPosition = typeof signaturesFilter[0] === 'string';

            if (signed && isPosition) {
                acc.signed_by_position.push(...signaturesFilter);
            } else if (signed) {
                acc.signed_by_user.push(...signaturesFilter);
            } else if (!signed && isPosition) {
                acc.not_signed_by_position.push(...signaturesFilter);
            } else {
                acc.not_signed_by_user.push(...signaturesFilter);
            }

            return acc;
        }, {
            signed_by_user: [],
            not_signed_by_user: [],
            signed_by_position: [],
            not_signed_by_position: [],
        });

        const filteredSignaturesFilters = Object.entries(signaturesFilters)
            .filter(([_, value]) => Array.isArray(value) && value.length > 0)
            .reduce((acc, [key, value]) => {
                acc[key] = value;
                return acc;
            }, {});
        let dateRange = this.props.filters.dateRange === 'personalized' ? [this.props.day.first, this.props.day.last] : [this.props.filters.dateRange];
        const urlPost = {
            project_id: this.props.projectId,
            dashboardmetric_config: {
                filters: {
                    ...(this.props.filters.levelIds.length > 0 && { level_ids: this.props.filters.levelIds }),
                    ...(this.props.filters.protocolIds.length > 0 && { protocol_ids: this.props.filters.protocolIds }),
                    ...(this.props.filters.cardCategoryIds.length > 0 && { card_category_id: this.props.filters.cardCategoryIds }),
                    ...(this.props.filters.status.length > 0 && { status: this.props.filters.status }),
                    ...(this.props.filters.customcardId.length > 0 && { customcard_id: this.props.filters.customcardId }),
                    ...(this.props.filters.usersInCharge.length > 0 && { users_in_charge: this.props.filters.usersInCharge }),
                    is_delayed: this.props.filters.isDelayed,
                    with_historical_observations: this.props.filters.historicalObservations,
                    ...(this.props.timeline && { date_filters: {
                        date_range: dateRange,
                        date_type: this.props.filters.timelineSelect,
                    }}),
                    ...filteredSignaturesFilters,
                },
                chart_type: this.props.metricKey,
            },
            dashboardmetric_name: this.props.metricKey,
        }
        console.log("urlPost",urlPost)
        const response = await postData('/web-api/save-dashboard-config', urlPost);
        if (response.status === 'success') {
            this.setState({ showSuccesToast: true });
        } else {
            this.setState({ showFailureToast: true });
        }
        this.setState({ saveInDashboardLoading: false });
    }

    render() {
        const isMetricEmpty = this.state.metricsHTML && !objectIsNotEmpty(this.state.metricsHTML);
        const fullScreenIcon = this.state.fullscreen ? <FullscreenExitIcon/> : <ZoomOutMapIcon/>;
        const fullScreenClass = this.state.fullscreen ? 'metrics-module full-metrics-module' : 'metrics-module';
        const zIndex = this.state.fullscreen ? 1000 : 1;
        const gridStackDisplay = !isMetricEmpty && this.state.metricsHTML
        return(
            <>
            <Snackbar className='w-100 p-0' onClose={() => this.setShowSuccessToast(false)} open={this.state.showSuccesToast} autoHideDuration={4000}>
                <MuiAlert elevation={6} variant="filled" severity="success">
                    <p className='text-center w-100 m-0'>
                        {_('Se ha guardado la métrica en tu dashboard exitosamente')}!
                    </p>
                </MuiAlert>
            </Snackbar>
            <Snackbar className='w-100 p-0' onClose={() => this.setShowFailureToast(false)} open={this.state.showFailureToast} autoHideDuration={4000}>
                <MuiAlert elevation={6} variant="filled" severity="error">
                    <p className='text-center w-100 m-0'>
                        ¡{_('Ha ocurrido un error al guardar la métrica en tu dashboard')}!
                    </p>
                </MuiAlert>
            </Snackbar>
            <Slide in={true} direction='left' style={{zIndex: zIndex}}>
                <div className={fullScreenClass}>
                    <p className='mt-0 mb-3'>
                        {this.props.description}
                        <span className="close-button" onClick={this.handleClose}><CloseIcon/></span>
                        <span className="close-button mr-2" onClick={this.handleFullScreen}>{fullScreenIcon}</span>
                        { this.state.saveInDashboardLoading ?
                            <CircularProgress 
                            className='float-right mr-2' 
                            style={{ 
                                width: '15px', 
                                height: '15px', 
                                position: 'relative', 
                                top: '3px'
                            }}/>
                        :
                            <Tooltip
                            title={_("Guardar en mi Dashboard")}
                            arrow
                            classes={{ tooltip: 'small-tooltip' }}
                            >
                            <span className="close-button mr-2" onClick={this.saveInDashboard} style={{ cursor: 'pointer' }}>
                                <MdDashboardCustomize size={17} />
                            </span>
                            </Tooltip>
                        }
                    </p>
                    <div className={`grid-stack grid-stack-${this.props.metricKey}`} style={{height:'100% !important', display: gridStackDisplay ? 'block' : 'none'}}></div>
                    { isMetricEmpty ? 
                        <div className='not-available-metric-container'>
                            <p>{_('Métrica No Disponible')}</p>
                        </div>
                        :
                        this.state.metricsHTML ? 
                            <div >
                                
                            </div>
                            : 
                            <div className="circular-progress-center">
                                <CircularProgress/>
                            </div>
                    }
                </div>
            </Slide>
            </>
        );
    } 
}

function mapStateToProps( state ){
    return {
        metrics              : state.switches.metrics,
        visibleCardsGroupIds : state.visibleCardsGroupIds,
        projectId            : state.projectData.id,
        filters              : state.filters,
        signaturesFilterHistoric : state.signaturesFilterHistoric,
        day                  : state.day,
        timeline             : state.switches.timeline,
    }
}

export default connect(mapStateToProps)(metricModule);